module.exports = __webpack_public_path__ + "img/team_viewer.6c40be1a.svg";